//@ts-nocheck
import React from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
// import styled from "@emotion/styled"?
// import MemoCamera from "@assets/Camera"
// import MemoCross from '@assets/Cross';
// import { createImage, deleteImage, loadPart, updatePart } from '@services/api/api';
// import { CurrentPartContext } from '@context/currentpart';
// import MemoPdf from '@assets/Pdf';
// import Loader from '@components/Spinner';
import { useTranslation } from 'react-i18next';
// import { PartContext } from '@context/part';
// import { UploadContextWrapper, useUpload, useUploadFiles } from '@context/upload';

import useSaveSurfaceDocumentNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-document-node';
import useSaveSurfaceImageNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-image-node';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import { useUploadSurfaceNodeFile } from 'components/canvas/hooks/use-upload-surface-node-file';
import { asyncAction } from 'utils/js';
import { compose, set } from 'lodash/fp';
import useCanvas from 'components/canvas/hooks/use-canvas';
import LinearProgress from '@mui/material/LinearProgress';
import { toast } from 'react-toastify';
import { ThemeProvider, createTheme } from '@mui/material';

const SmallText = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;

  color: #fff;
  text-align: center;
`;
const Photos = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-color: ${(props) => getColor(props)};
  box-sizing: border-box;
  border-radius: 7px;
  padding: 14px 22px;
  justify-content: center;
  align-items: center;
  margin-horizontal: 8px;
  margin-bottom: 20px;
`;

// const CameraIcon = styled(MemoCamera)`
//   margin-bottom: 10px;

// `

// const CrossIcon = styled(MemoCross)`

// `

const IconHolder = styled.div`
  top: 10px;
  right: 10px;
  z-index: 5;
`;

const Image = styled.div`
  position: 'relative';
  width: 65px;
  height: 56px;

  background: #353a3d;
  opacity: 1;
  border-radius: 6px;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const ImageX = styled.img`
  top: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover; /*magic*/
  border-radius: 6px;
`;
const Image1 = styled.img`
  position: relative;
  width: 65px;
  height: 56px;
  border-radius: 6px;
`;

const getColor = (props) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isDragActive) {
    return '#2196f3';
  }
  return '#0000';
};

const SmallZone = styled.div`
  width: 63px;
  height: 54px;

  flex-direction: column;
  align-items: center;
  border-width: 2px;
  border-radius: 7px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background: #ffffff;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
  margin-bottom: 24px;
  cursor: pointer;
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  /* flex-direction: column;
  align-items: center; */
  width: calc(100vw - 8px);
  height: calc(100vh - 8px);
  flex: 1;
  z-index: 1000;
  /* padding: 200px; */
  border-width: 4px;
  border-radius: 7px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  /* background: #FFFFFF; */
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
`;

const Plus = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 38px;
  line-height: 55px;
  background-color: #fff;
  color: #6984db;
  width: 60px;
  text-align: center;
`;

const ImageRow = styled.div`
  margin-top: 100px;
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const Preview = styled.div`
  width: 405px;
  height: 56px;
  border-radius: 5px;
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const MagnifyingGlassIcon = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 5px;
  top: 5px;
  cursor: pointer;
  border-radius: 30px;
  background-color: #c21a1a;
`;

const ThumbImg = styled.img`
  width: 65px;
  height: 56px;
  border-radius: 5px;
  margin-bottom: 5px;
  position: relative;
`;

const Loader = styled.div`
  /* position: absolute;
  display: flex; */
  width: 100px;
  height: 100px;
  /* align-items: center;
  justify-content: center; */
  background-color: #b61717;
  border-radius: 5px;
  z-index: 1;
`;

const MemoPdf = styled.div`
  /* position: absolute;
  display: flex; */
  width: 100px;
  height: 100px;
  /* align-items: center;
  justify-content: center; */
  background-color: #09bb03;
  border-radius: 5px;
  z-index: 1;
`;

const LoaderConatainer = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgba(1, 1, 1, 0.3);
  border-radius: 5px;
  z-index: 1;
`;
const FileContainer = styled.div`
  /* margin-bottom: 10px; */
  width: 100%;
  height: 100%;
  flex: 1;
`;
const ErrorContainer = styled.div`
  text-align: center;
  margin-top: 10px;
  color: #ff4b4b;
  font-size: 13px;
  line-height: 15px;
`;

const UploadProgressCon = styled.div`
  position: absolute;
  width: 400px;
  height: 50px;
  left: 100px;
  bottom: 20px;
  cursor: pointer;
  border-radius: 5px;
  background-color: #fff;
`;

function UploadProgress({ files: initialFiles, progress, children }) {
  const file = initialFiles.filter((f) => f.inProgress == true)?.at(0);

  const theme = createTheme({
    // palette: {
    //   primary: {
    //     // main: red[500],
    //   },
    // },
  });

  return (
    <ThemeProvider theme={{ ...theme }}>
      <UploadProgressCon>
        <Title>Uploading {initialFiles.length} Files </Title>
        {<Path> Current File {file?.file?.path} </Path>}
        <LinearProgress color="success" variant="determinate" value={10} />
        {/* <></> */}
      </UploadProgressCon>
    </ThemeProvider>
  );
}

const Title = styled.div`
  border-radius: 5px;
  position: relative;
  margin-left: 8px;
  margin-top: 13px;
  color: #000;
  margin-bottom: 8px;
`;

const Path = styled.div`
  /* height: 56px; */
  border-radius: 5px;
  position: absolute;
  margin-left: 8px;
  margin-top: 13px;
  top: 0;
  right: 8px;
  color: #000;
  /* background-color:#f00; */
`;

function StyledDropzone({ files: initialFiles, children, surface }) {
  const [files, setFiles] = React.useState([]);
  const [position, setPosition] = React.useState({ x: 200, y: 300 });
  const [error, setError] = React.useState();
  const { t } = useTranslation();

  // const {setPart} = React.useContext(PartContext)
  // const { partId } = React.useContext(CurrentPartContext)

  // const uploadFiles = useUploadFiles()
  //
  // const { upload, remove,  addRefreshCallback, removeRefreshCallback } = useUpload()

  const upload = () => {};

  const surfaceId = surface;

  const saveSurfaceImageNode = useSaveSurfaceDocumentNode(surfaceId);
  const uploadFile = useUploadSurfaceNodeFile(surfaceId);
  const saveNodeInCache = useSaveNodeInCache();

  const { getPointerPosition } = useCanvas();

  const [progress, setProgress] = React.useState(0);

  async function onSubmit(input, { setSubmitting }) {
    const saveOperation = saveSurfaceImageNode;

    console.warn('XXXX1', input.file);
    console.warn('XXXX2 url', input.url);

    let file_input = input.file;

    // if (file_input && file_input.url) {
    //   console.warn('XXXX2 url FETCH ', file_input);
    //   let myBlob = (
    //     await axios.get(file_input.url, {
    //       responseType: 'blob',
    //       headers: {
    //         'Cache-Control': 'no-cache',
    //         Pragma: 'no-cache',
    //         Expires: '0',
    //       },
    //       // withCredentials : true,
    //       // headers: {
    //       //   "Origin":"http://my.cortlex.at"
    //       // }
    //     })
    //   ).data;
    //   file_input = new File([myBlob], 'name', { type: 'image/jpg' });

    //   console.warn('BLOBS ', file_input);
    //   // file.
    // }

    const response = await saveOperation({ variables: { input } });

    if (response.isFailure) {
      console.log('ERROR ', response);
      setSubmitting(false);
      removeFile(input.file);
      toast.error(response.getErrorMessage());

      return response;
    }

    const node = response.getField('data');

    // let file = input.file;

    // if (file_input.img) {
    //   console.warn('XXXX2 url FETCH ', file_input);
    //   let myBlob = (
    //     // await axios.get(file_input.img, {
    //     //   responseType: 'blob',
    //     })
    //   ).data;
    //   file_input = new File([myBlob], 'name', { type: 'image/jpg' });

    //   console.warn('BLOBS ', file_input);
    //   // file.
    // }

    // Upload a file  then set correct values and submit data
    const [error] = await asyncAction(
      uploadFile(file_input, node.id, (p) => {
        const number = (p.loaded / p.total) * 100;
        console.log('ON PROGRESS', p, number);
        setProgress(number);
      }),
    );

    if (error) {
      // Sentry.captureException(error);
    }

    saveNodeInCache(set('updatedAt', new Date().toISOString(), node));

    removeFile(input.file);

    return response;
  }

  const fetchFiles = React.useCallback(() => {
    // refreshPart()
  }, []);

  // React.useEffect(() => {
  // // addRefreshCallback(fetchFiles)
  // // return () => removeRefreshCallback(fetchFiles)
  // }, [fetchFiles, addRefreshCallback, removeRefreshCallback])
  const allFiles = [...files];

  const onDrop = React.useCallback(
    (acceptedFilesP, rejectedFiles, event) => {
      // upload(acceptedFilesP)
      const pos = getPointerPosition();
      const x = acceptedFilesP.map((f, index) => ({
        file: f,
        position: { x: pos.x + index * 250, y: pos.y },
      }));
      console.log('XXX EVENTS', pos);

      console.log('XXX EVENTS MAP', x);
      console.log('XXX EVENTS A', acceptedFilesP, rejectedFiles);

      setFiles([...allFiles, ...x]);
      // setPosition({})
    },
    [allFiles, getPointerPosition],
  );

  React.useEffect(() => {
    if (files.length > 0) {
      const file = files.filter((f) => f.inProgress != true)?.at(0);
      if (file) {
        const format = file.file.type == 'application/pdf' ? 'PDF' : 'FILE';
        console.log('FIOLE', file.position, format);
        onSubmit(
          {
            mimeType: file.file.type,
            file: file.file,
            name: file.file.path,
            surface: surfaceId,
            format,
            position: file.position,
          },
          { setSubmitting: (a) => {} },
        );
      }
      files[0].inProgress = true;
      setFiles(files);
    }
  }, [files, setFiles]);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    fileRejections,
  } = useDropzone({ noClick: true, onDrop: onDrop });

  const removeFile = async (file) => {
    if (file.localId !== undefined) {
      // remove(file.localId)
    } else {
      // await deleteImage(file.id)
      // await refreshPart()
    }
    let newList;
    if (file.id) {
      newList = files.filter((f) => f.id !== file.id);
    } else {
      newList = files.filter((f) => f.file.path !== file.path);
    }
    setFiles(newList);

    setError(null);
  };

  //   async function refreshPart() {
  //     const partresponse = await loadPart(partId)
  //     const partEntry = partresponse.part
  //     if (setPart) setPart(partEntry)
  //   }

  const renderPreview = (file) => {
    console.log(' FILE ', file);
    if (file.id) {
      const isPDF = file.contentType == 'application/pdf';
      return (
        <Preview>
          {/* {file.status == "pending" && <LoaderConatainer><Loader/></LoaderConatainer>}
          {!isPDF && <ThumbImg src={file.contentUrl || file.preview} alt="" />}
          {isPDF && <MemoPdf/>} */}
          {JSON.stringify(file)}

          <MagnifyingGlassIcon
            onClick={() => removeFile(file)}></MagnifyingGlassIcon>
        </Preview>
      );
    } else {
      const isPDF = file.name.includes('.pdf');
      return (
        <Preview>
          {/* {file.status == "pending" && <LoaderConatainer><Loader/></LoaderConatainer>}
          {!isPDF && <ThumbImg src={file.preview} alt="" />} */}

          {/* TODO */}
          {/* {isPDF && <MemoPdf/>} */}
          {/* {JSON.stringify(file)} */}
          <MagnifyingGlassIcon
            onClick={() => removeFile(file)}></MagnifyingGlassIcon>
        </Preview>
      );
    }
  };

  return (
    <FileContainer>
      <Container
        {...getRootProps({ isDragActive, isDragAccept, isDragReject })}>
        <input {...getInputProps()} />
        {/* <CameraIcon></CameraIcon> */}
        {/* <SmallText>{t("local:upload_pictures_and_drawings")}</SmallText> */}
        {children}
        {allFiles.length > 0 && (
          <UploadProgress files={allFiles} progress={progress}></UploadProgress>
        )}
      </Container>
      {/* {error && <ErrorContainer>{t("local:image_upload_error")}</ErrorContainer>} */}
    </FileContainer>
  );
}

export default StyledDropzone;
